// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  ruleId: __t.u64().name("rule_id"),
  projectId: __t.u32().name("project_id"),
  firedAt: __t.timestamp().name("fired_at"),
  value: __t.string(),
  resolvedAt: __t.option(__t.timestamp()).name("resolved_at"),
  acknowledgedAt: __t.option(__t.timestamp()).name("acknowledged_at"),
});
